export enum MaintenanceStatusType {
  Unspecified = 'STATUS_UNSPECIFIED',
  OnMaintenance = 'STATUS_MAINTENANCE',
  NotMaintenance = 'STATUS_NOT_MAINTENANCE',
}

export interface MaintenanceStatusResponse {
  status: MaintenanceStatusType;
}
